export const REWARDS_STORE_UPDATE_STRATEGY = {
    set: "set",
    add: "add",
} as const;
